import React from 'react';
import RecordSearchSelect from '../RecordSearchSelect';

const CONTACT_PARAMS = { page_size: 20 };

const contactRow = (c) => <>{c.first_name} {c.last_name} <span className="text-xs text-stone-400">{c.email}</span></>;

/** Search contacts and pick one: `onChange(contactId, contact)`, or `onChange('')` when the user types again
 *  after a pick. `excludeIds` hides contacts the caller already has; `disabled` disables the box and `disabledReason`
 *  explains it (a reason alone disables it too). */
export default function ContactSearchSelect({ value, onChange, excludeIds, placeholder = 'Search contacts…', emptyText, disabled, disabledReason }) {
    return (
        <RecordSearchSelect
            endpoint="/contacts" params={CONTACT_PARAMS} rowKey="contact_id" renderRow={contactRow}
            excludeIds={excludeIds} onPick={c => onChange?.(c.contact_id, c)}
            onQueryChange={() => { if (value) onChange?.(''); }}
            placeholder={placeholder} emptyText={emptyText} disabled={disabled} disabledReason={disabledReason} testId="contact-search-select" />
    );
}
